import type { MappingProfile } from '@automapper/core';
import { convertUsing, mapFrom } from '@automapper/core';
import nilStringConverter from '@tcs/create-account/mapping/converters/nilStringConverter';
import { Address } from '@tcs/create-account/types/Address';
import { PartnerConfigurationType } from '@tcs/create-account/utils/prismic/types';

export const addressProfile: MappingProfile = (mapper) => {
  mapper
    .createMap<PartnerConfigurationType, Address>(
      'PartnerConfigurationType',
      'Address'
    )
    .forMember(
      (dest) => dest.line1,
      mapFrom((source) => source.representative_address_line_1)
    )
    .forMember(
      (dest) => dest.line2,
      convertUsing(
        nilStringConverter,
        (source) => source.representative_address_line_2
      )
    )
    .forMember(
      (dest) => dest.city,
      mapFrom((source) => source.representative_address_city)
    )
    .forMember(
      (dest) => dest.zipCode,
      mapFrom((source) => source.representative_address_zip_code)
    )
    .forMember(
      (dest) => dest.state,
      mapFrom((source) => source.representative_address_state)
    )
    .forMember(
      (dest) => dest.country,
      mapFrom((source) => source.representative_address_country)
    );
};
